module.exports = __webpack_public_path__ + "static/media/28.47c2cd6c.jpg";